import { ApiRequestEnum } from '../enums/api-request.enum';
import { ConfigService } from './config.service';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { take } from 'rxjs/operators';
import { SessionService } from "../../shared/services/session.service";
import { environment } from '../../../environments/environment';

@Injectable({
	providedIn: 'root',
})
export class ApiService {
	private headers = new HttpHeaders();

	constructor(
		private http: HttpClient,
		private configService: ConfigService,
		private sessionService: SessionService,
	) {
		this.sessionService.state$.subscribe(result => {
			if (result && result.token) {
				this.headers = this.headers.set('Authorization', `Bearer ${result.token}`);
			} else {
				this.removeAuthorizationHeader();
			}
		});
		// if (process.env.NODE_ENV === 'development') {
		// 	this.headers = this.headers.set('ngrok-skip-browser-warning', 'true'); // TODO: Remove for production
		// }
		if (!environment.production) {
			this.headers = this.headers.set('ngrok-skip-browser-warning', 'true');
		}
	}

	get(apiRequest: string, params?: any) {
		let url = this.configService.config.api.baseUrl + apiRequest;

		return this.http.get(url, {
			headers: this.headers,
			params: params,
			withCredentials: true
		}).pipe(take(1));
	}

	post(apiRequest: string, data: Object = {}) {
		const url = this.configService.config.api.baseUrl + apiRequest;
		return this.http.post(url, data, {
			headers: this.headers,
			withCredentials: true
		}).pipe(take(1));
	}

	delete(apiRequest: string, params?: string) {
		let url = this.configService.config.api.baseUrl + apiRequest;
		if (params) {
			url = url + params;
		}
		return this.http.delete(url, {
			headers: this.headers
		}).pipe(take(1));
	}

	put(apiRequest: string, data: Object = {}, params?: string) {
		let url = this.configService.config.api.baseUrl + apiRequest;
		if (params) {
			url = url + params;
		}
		return this.http.put(url, data, {
			headers: this.headers
		}).pipe(take(1));
	}

	patch(apiRequest: string, data?: any) {
		let url = this.configService.config.api.baseUrl + apiRequest;

		return this.http.patch(url, data, {
			headers: this.headers
		}).pipe(take(1));
	}


	removeAuthorizationHeader() {
		this.headers = this.headers.delete('Authorization');
	}
}
